import axios from 'components/Axios';
import { notification, notificationLastSeen, notificationStatus, saveDeviceToken } from '../APIEndPoint';

const getNotifications = (payload) => {
  const promise = axios.get(
    `${notification}?entity_type=${
      payload?.tab === 'all' ? '' : payload?.tab
    }&interactionTime=${payload?.currentTime}&page=${payload?.page || 0}&size=${
      payload?.size || 10
    }`
  );
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const updateNotificationRead = (payload) => {
  const promise = axios.put(notificationStatus, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const updateNotificationLastSeen = (payload) => {
  const promise = axios.post(notificationLastSeen, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const deleteNotification = (id) => {
  const promise = axios.delete(`${notification}/${id}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const setPushNotificationToken = (payload) => {
  const promise = axios.post(saveDeviceToken, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

export { getNotifications, updateNotificationRead, updateNotificationLastSeen, deleteNotification, setPushNotificationToken };
